<template>
  <div>
    <div v-if="organisation">
      <h1 v-if="organisation">{{ organisation.code }} - Download data</h1>
      <p>
        <button type="button" class="btn btn-primary" @click="generateDownloadData"><i
            class="fa-solid fa-file-excel"></i> All shifts
        </button>
      </p>
      <p>
        <button type="button" class="btn btn-primary" @click="generateDownloadPlanning"><i
            class="fa-solid fa-file-excel"></i> Planning
        </button>
      </p>
    </div>
    <p v-else>Loading organisation details...</p>
  </div>
</template>

<script>

import {API_BASE_URL} from "@/config";

export default {
  name: "OrganisationDownloadDataPage.vue",
  data() {
    return {
      organisation: null,
      slug: this.$route.params.slug,
    };
  },
  mounted() {
    this.fetchBasicOrganisationDetails();
  },
  methods: {
    getTimestamp() {
      const now = new Date();
      const pad = n => n.toString().padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    async fetchBasicOrganisationDetails() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/basic`, {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          this.organisation = data;
          document.title = `${this.organisation.name} - Downloads`;
        }
      } catch (error) {
        console.error('Error fetching organisation details:', error);
      }
    },
    async generateDownloadData() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/downloads/all-shifts`, {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {

          // Retrieve the blob from the response
          const blob = await response.blob();

          // Create a URL for the blob
          const url = window.URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.organisation.code} All Shifts ${this.getTimestamp()}.xlsx`; // Set the file name
          document.body.appendChild(a);
          a.click(); // Trigger the download
          a.remove(); // Remove the anchor element

          // Revoke the object URL to free up memory
          window.URL.revokeObjectURL(url);
        }


      } catch (error) {
        console.error('Error generating download data:', error);
      }
    },
    async generateDownloadPlanning() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/downloads/shift-planning`, {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {

          // Retrieve the blob from the response
          const blob = await response.blob();

          // Create a URL for the blob
          const url = window.URL.createObjectURL(blob);

          // Create a temporary anchor element to trigger the download
          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.organisation.code} Planning ${this.getTimestamp()}.xlsx`; // Set the file name
          document.body.appendChild(a);
          a.click(); // Trigger the download
          a.remove(); // Remove the anchor element
          // Revoke the object URL to free up memory
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error('Error generating download planning:', error);
      }
    }
  }
}
</script>


